import React from "react";
import { Avatar, Grid } from "tabler-react";
import moment from "moment";
const Profile = ({ profile }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Col width={2}>
          <div style={{ paddingTop: 20 }}>
            <Avatar size="xxl" imageURL={profile.avatar} />
          </div>
        </Grid.Col>
        <Grid.Col>
          <div style={{ paddingRight: 10 }}>
            <table className="table card-table table-vcenter text-nowrap">
              <tr>
                <th>Employee No</th>
                <td>{profile.employeeNo}</td>
              </tr>
              <tr>
                <th>Name</th>
                <td>{profile.fullname}</td>
              </tr>
              <tr>
                <th>Department</th>
                <td style={{ textTransform: "uppercase" }}>
                  {profile.department.name}
                </td>
              </tr>
              <tr>
                <th>Gender</th>
                <td style={{ textTransform: "capitalize" }}>
                  {profile.gender}
                </td>
              </tr>
              <tr>
                <th>Contact Number</th>
                <td>{profile.contactNumber}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{profile.address}</td>
              </tr>
              <tr>
                <th>DOB</th>
                <td> {moment(profile.birthdate).format("MMM Do YYYY")}</td>
              </tr>
              {getTerminatedButton(profile)}
            </table>
          </div>
        </Grid.Col>
      </Grid.Row>
    </Grid>
  );
};
function getTerminatedButton(item) {
  if (item.terminated.status === true) {
    return (
      <tr>
        <th>Reason for Termination</th>
        <td>{item.terminated.reason}</td>
      </tr>
    );
  }
  return;
}

export default Profile;
